import axios from 'axios';

export const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const CATEGORIES = [
  { id: 'warsztat', label: 'Warsztat' },
  { id: 'magazyn', label: 'Magazyn' },
  { id: 'inne', label: 'Inne' },
];
export const fmtPLN = (v) => `${(v || 0).toLocaleString('pl-PL', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} zł`;
export const fmtH = (v) => `${(v || 0).toLocaleString('pl-PL', { maximumFractionDigits: 2 })} h`;
export const fmtDateTime = (iso) => (iso ? new Date(iso).toLocaleString('pl-PL', { timeZone: 'Europe/Warsaw' }) : '—');

// Polish calendar date (Europe/Warsaw), never UTC
export const todayPL = () => new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Warsaw' }).format(new Date());
export const currentMonthPL = () => todayPL().slice(0, 7);

export const hoursBetween = (start, end, breakMin) => {
  if (!start || !end) return null;
  const [sh, sm] = start.split(':').map(Number);
  const [eh, em] = end.split(':').map(Number);
  const mins = eh * 60 + em - (sh * 60 + sm) - (Number(breakMin) || 0);
  return mins > 0 ? Math.round((mins / 60) * 100) / 100 : null;
};

export const errMsg = (e, fallback) => {
  const d = e?.response?.data?.detail;
  return typeof d === 'string' ? d : fallback;
};

export const godzinyApi = {
  workers: () => axios.get(`${API_URL}/godziny/workers`).then((r) => r.data),
  pending: () => axios.get(`${API_URL}/godziny/pending`).then((r) => r.data),
  pendingCount: () => axios.get(`${API_URL}/godziny/pending-count`).then((r) => r.data.count),
  summary: (month) => axios.get(`${API_URL}/godziny/summary`, { params: { month } }).then((r) => r.data),
};
